import type { IDrawTool } from "$src/domain/designs/editor/IDrawTool";
import type { ISceneViewCanvas } from "$src/domain/designs/editor/ISceneViewCanvas";
import type { ITopViewCanvas } from "$src/domain/designs/editor/ITopViewCanvas";

export class DesignEditor {

    private topViewCanvas?: ITopViewCanvas
    private sceneViewCanvas?: ISceneViewCanvas;
    private activeTool?: IDrawTool;
    
    public setTopViewCanvas(topViewCanvas: ITopViewCanvas) {
        this.topViewCanvas = topViewCanvas;
    }

    public setSceneViewCanvas(sceneViewCanvas: ISceneViewCanvas) {
        this.sceneViewCanvas = sceneViewCanvas;
    }

}